module.exports = __webpack_public_path__ + "static/img/magnifier.4ee57c25.svg";